/*
 * CRO Sep 2026 - product page helpers
 *  1. "Read more" for the collapsed mobile description
 *  2. <sticky-atc>: mobile sticky Add to cart bar that proxies the real buy-box button
 */
(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  /* 1. Description clamp ------------------------------------------------ */
  function initDescriptionClamp(wrapper) {
    if (wrapper.dataset.clampReady) return;
    wrapper.dataset.clampReady = 'true';

    var body = wrapper.querySelector('.product__description');
    var toggle = wrapper.querySelector('.product__description-toggle');
    if (!body || !toggle) return;

    function update() {
      if (wrapper.classList.contains('is-expanded')) return;
      // Only show the toggle when the clamp actually hides something.
      toggle.hidden = !(mobileQuery.matches && body.scrollHeight > body.clientHeight + 4);
    }

    toggle.addEventListener('click', function () {
      var expanded = wrapper.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded ? 'Read less' : 'Read more';
      toggle.hidden = false;
    });

    update();
    window.addEventListener('load', update);
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', update);
  }

  function initAllClamps() {
    document.querySelectorAll('[data-description-clamp]').forEach(initDescriptionClamp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllClamps);
  } else {
    initAllClamps();
  }

  /* 2. Sticky add to cart ---------------------------------------------- */
  if (customElements.get('sticky-atc')) return;

  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('[data-sticky-button]');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.mainButton = document.getElementById('ProductSubmitButton-' + this.sectionId);
        this.priceSource = document.getElementById('price-' + this.sectionId);
        if (!this.mainButton || !this.button) return;

        this.mainVisible = true;
        this.footerVisible = false;

        this.button.addEventListener('click', this.onClick.bind(this));

        // Show only while the real Add to cart button is off screen (above or below) and the
        // footer isn't in view.
        this.observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(
              function (entry) {
                if (entry.target === this.footer) this.footerVisible = entry.isIntersecting;
                else this.mainVisible = entry.isIntersecting;
              }.bind(this)
            );
            this.toggle();
          }.bind(this),
          { threshold: 0 }
        );
        this.observer.observe(this.mainButton);
        this.footer = document.querySelector('.footer, footer');
        if (this.footer) this.observer.observe(this.footer);

        // Dawn re-renders the price and the buy button on variant change, so watch for changes
        // instead of hooking into product-info.js.
        this.sync = this.sync.bind(this);
        this.mutation = new MutationObserver(this.sync);
        if (this.priceSource) this.mutation.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
        var form = this.mainButton.closest('product-form') || this.mainButton.parentElement;
        this.mutation.observe(form, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
        if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', this.toggle.bind(this));
        this.sync();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mutation) this.mutation.disconnect();
        document.body.classList.remove('sticky-atc-visible');
      }

      currentMainButton() {
        // The buy box may have been re-rendered on variant change; re-resolve by id.
        var el = document.getElementById('ProductSubmitButton-' + this.sectionId);
        if (el && el !== this.mainButton) {
          this.observer.unobserve(this.mainButton);
          this.mainButton = el;
          this.observer.observe(el);
        }
        return this.mainButton;
      }

      mainButtonUsable() {
        var btn = this.currentMainButton();
        // offsetParent is null when the button (or its wrapper, e.g. .sb-hide-on-subscribe while a
        // subscription option is selected) is display:none.
        return btn && btn.offsetParent !== null;
      }

      sync() {
        var btn = this.currentMainButton();
        if (!btn) return;

        var disabled = btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true';
        var loading = btn.classList.contains('loading');
        var label = (btn.querySelector('span') || btn).textContent.trim();

        if (!this.mainButtonUsable()) {
          this.button.textContent = 'Choose option';
          this.button.disabled = false;
        } else {
          if (label) this.button.textContent = label;
          this.button.disabled = disabled && !loading;
        }
        this.button.classList.toggle('is-loading', loading);

        if (this.priceSource && this.priceEl) {
          var items = this.priceSource.querySelectorAll('.price-item');
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.tagName === 'S' || item.closest('s')) continue;
            if (!item.getClientRects().length) continue;
            var text = item.textContent.trim();
            if (text) {
              this.priceEl.textContent = text;
              break;
            }
          }
        }
      }

      toggle() {
        var show = mobileQuery.matches && !this.mainVisible && !this.footerVisible;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        this.button.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('sticky-atc-visible', show);
        if (show) this.sync();
      }

      onClick() {
        if (!this.mainButtonUsable()) {
          // e.g. subscription selected (buy box handled by the subscription app) - take the
          // shopper to the options instead of silently doing nothing.
          var target = document.getElementById('ProductInfo-' + this.sectionId);
          var price = this.priceSource || target;
          if (price) price.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        var btn = this.currentMainButton();
        if (btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true') return;
        btn.click();
      }
    }
  );
})();
